import { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import listCategory from './home_components/ListCategoryJson';
import LoginSectionHeader from './header_components/LoginSectionHeader';
import InfoUserLoggedHeader from './header_components/InfoUserLoggedHeader';
import MobileHeaderRight from './header_components/MobileHeaderRight';
import colors from '../styles/colors';
import useResponsiveRedux from './Hooks/useResponsiveRedux';
import type { RootState } from '../types';

const Container = styled.header`
  height: 70px;
  width: 100%;
  background-color: ${colors.bgColorBlack};

  & p {
    margin: 0 !important;
    padding: 0 !important;
  }

  & p.section_name {
    color: white;
    padding: 0 5px !important;
  }
`;

const MenuSection = styled.div`
  display: flex;
  justify-content: end;

  & .link_css {
    text-decoration: none;

    &:hover .section_name {
      cursor: pointer;
      color: gold;
    }
  }

  @media screen and (max-width: 768px) {
    width: 0;
    visibility: hidden;
  }
`;

const BoxImg = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  & img {
    cursor: pointer;
    object-fit: contain;
    height: 80%;
  }
`;

const ContainerMobileHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 70px;
  padding: 0 8px;
  background-color: ${colors.bgColorBlack};
`;

const BoxAvatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  min-width: 0;
`;

const BoxHeaderLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  height: 100%;

  & img.logo-mobile {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    cursor: pointer;
  }
`;

const BoxSpacer = styled.div`
  flex: 1;
  min-width: 0;
`;

interface CategoryItem {
  title: string;
  link: string;
  isInHeader?: boolean;
}

const Header: FC = () => {
  const { userLoggedState } = useSelector((state: RootState) => state.auth);
  const { isMobile } = useResponsiveRedux();
  const navigate = useNavigate();

  const goToHomepage = (): void => {
    navigate('/');
  };

  const renderMobileHeader = (): ReactElement => {
    return (
      <ContainerMobileHeader className="d-flex">
        <BoxAvatar>
          <MobileHeaderRight user={userLoggedState ?? null} />
        </BoxAvatar>
        <BoxHeaderLogo>
          <img
            className="logo-mobile"
            src={process.env.REACT_APP_STORAGE_URL + 'img/utilities/Logo.png'}
            alt="GWF Logo"
            onClick={() => goToHomepage()}
          />
        </BoxHeaderLogo>
        <BoxSpacer />
      </ContainerMobileHeader>
    );
  };

  return !isMobile ? (
    <Container className="d-flex">
      <MenuSection className="MenuSection d-flex align-items-center d-flex col-md-4">
        {(listCategory as CategoryItem[]).map((category, index) =>
          category.isInHeader ? (
            <Link className="link_css" key={category.title + '-' + index} to={category.link}>
              <p className="section_name">{category.title}</p>
            </Link>
          ) : null
        )}
      </MenuSection>

      <BoxImg className="col-8 col-md-4">
        <img
          src={process.env.REACT_APP_STORAGE_URL + 'img/utilities/Logo.png'}
          alt="GWF Logo"
          onClick={() => goToHomepage()}
        />
      </BoxImg>

      {userLoggedState ? (
        <InfoUserLoggedHeader user={userLoggedState} />
      ) : (
        <LoginSectionHeader />
      )}
    </Container>
  ) : (
    renderMobileHeader()
  );
};

export default Header;
